import {StrtDashboardSortColumn} from './StrtDashboardSortColumn';

export interface StrtDashboardRequest {
  filters: string[];
  includeHierarchy: boolean;
  offset: number;
  pageSize: number;
  searchTerm: string | null;
  sortColumns: StrtDashboardSortColumn[];
}

export const DefaultDashboardRequest: StrtDashboardRequest = {
  filters: [],
  includeHierarchy: false,
  offset: 0,
  pageSize: 50,
  searchTerm: null,
  sortColumns: [{
    columnName: 'strategyName',
    direction: 'asc'
  }]
};

